import Joi from 'joi';

import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { BankAccount } from '@/modules/bankAccount/bankAccount.model';
import { objectId } from '@/shared/validations/custom.validation';

export const createBankAccount = () => ({
  body: generateJoiValidation(BankAccount.schema),
});

export const updateBankAccount = () => ({
  query: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: generateJoiValidation(BankAccount.schema, true),
});

export const getBankAccount = {
  query: Joi.object().keys({
    name: Joi.string(),
    sortBy: Joi.string(),
    search: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    companyId: Joi.string(),
    includeTimeStamps: Joi.boolean(),
  }),
};

export const getBankAccountById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};

export const deleteBankAccountById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};
